import styled from 'styled-components'

type WrapperProps = {
  $centralize: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  .slick-track,
  .slick-list {
    display: flex;
  }

  .slick-track {
    left: ${({ $centralize }) => ($centralize ? '20px' : 'inherit')};
  }

  .slick-slide {
    opacity: 0.6;

    & > div {
      display: flex;
      flex: 1 0 auto;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0 0.25rem;

      & > * {
        width: 100%;
        height: 100%;
      }
    }

    &.slick-active {
      opacity: 1;
    }
  }

  .slick-prev,
  .slick-next {
    width: 1.5rem;
    height: 1.5rem;
    background-color: var(--gray-500);
    color: var(--gray-100);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    display: flex !important;
    justify-content: center;
    align-items: center;
    transition: background-color 0.2s;
    z-index: 1;
  }

  .slick-prev:hover,
  .slick-next:hover {
    &:hover {
      background-color: var(--gray-400);
    }
  }

  .slick-prev {
    left: 0.1875rem;
  }

  .slick-next {
    right: 0.1875rem;
  }

  .slick-prev.slick-disabled,
  .slick-next.slick-disabled {
    visibility: hidden;
  }
`

Wrapper.displayName = 'Wrapper'
